import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../../utils/network/generated/protoTypes";
import { actionModalCloseAll } from "../../../modals/actionModal";
import { actionInventoryInfoRemoveResource } from "../../inventory/actionInventoryInfo";
import { actionOutskirtsInfoUpdateStageInfo, TypeActionOutskirtsInfo, } from "../actionOutskirtsInfo";
export var epicOutskirtBuildingUpgradeRequest = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionOutskirtsInfo.UpgradeRequest), switchMap(function (action) {
        return deps.netSend({
            id: CommandCode.UpgradeOutskirt,
            props: {
                playerId: state$.value.playerInfo.playerId,
                typeId: action.building.balancing.id,
            },
        });
    }), retry(), switchMap(function (res) {
        return from([
            actionModalCloseAll(),
            actionInventoryInfoRemoveResource(res.cost),
            actionOutskirtsInfoUpdateStageInfo(res.upgrade),
        ]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/outskirts/epics/epicOutskirtBuildingUpgradeRequest.ts
// module id = 1924
// module chunks = 3